export default __webpack_public_path__ + "static/media/watsapp.8ed6b45f.png";